import { googleSheetApiSupport } from "../../../Vendor/Google/Support/GoogleSheetApiSupport";
import { operationCommonConfigCombination } from "../Combination/OperationCommonConfigCombination";
import { contentSplitSupport } from "../../../Core/Support/ContentSplitSupport";


/***
 * 取得公用區塊設定檔 (含 “主打產品區”, “活動辦法”)
 * 回傳 “主打產品列表”, “活動辦法列表”
 */
export function OperationCommonInfoService() {
  // 串接 sheet 表單取得公用區設定檔
  let _getOperationCommonConfig = async function (spread_id, sheet_id) {
    let operation_common_config_list = await googleSheetApiSupport(spread_id, sheet_id);

    // 將 common config 格式轉為兩層物件並回傳
    let common_config_parse_result = operationCommonConfigCombination(operation_common_config_list);

    return common_config_parse_result;
  };

  // 取得主打產品列表
  let _getFlagShipInfo = async function (google_spread_sheet_id, flagship_spread_sheet_id) {
    let flagship_sheets_list = await googleSheetApiSupport(google_spread_sheet_id, flagship_spread_sheet_id);

    // 將主打產品的介紹斷行
    flagship_sheets_list.forEach(function (flagship_product) {
      flagship_product.content_after_split = contentSplitSupport(flagship_product.introduction_content);
    });

    return flagship_sheets_list;
  };

  // 取得活動辦法列表
  let _getActiveRules = async function (google_spread_sheet_id, active_rule_sheet_id) {
    let active_rule_sheets_list = await googleSheetApiSupport(google_spread_sheet_id, active_rule_sheet_id);

    // 將注意事項斷行
    active_rule_sheets_list.forEach(function (active_rule) {
      active_rule.rule = contentSplitSupport(active_rule.active_content);
    });

    return active_rule_sheets_list;
  };

  let _getFlagShipInfoWithNoSplit = async function (google_spread_sheet_id, flagship_spread_sheet_id) {
    let flagship_sheets_list = await googleSheetApiSupport(google_spread_sheet_id, flagship_spread_sheet_id);

    return flagship_sheets_list
  }

  return {
    getOperationCommonConfig: _getOperationCommonConfig,
    getFlagShipInfo: _getFlagShipInfo,
    getActiveRules: _getActiveRules,
    getFlagShipInfoWithNoSplit: _getFlagShipInfoWithNoSplit
  };
}
